import { useAuth } from "./contexts/AuthContext";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/Login";
import Sidebar from "./components/Sidebar";
import DashboardPage from "./pages/Dashboard";
import ManualSendPage from "./pages/ManualSend";
import RecipientsPage from "./pages/Recipients";
import ListsPage from "./pages/Lists";
import CampaignsPage from "./pages/Campaigns";
import FormsPage from "./pages/Forms";
import LeadsPage from "./pages/Leads";
import AutomationsPage from "./pages/Automations";
import SettingsPage from "./pages/Settings";
import PublicFormPage from "./pages/PublicForm";

function AuthenticatedApp() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-fuchsia-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) return <LoginPage />;

  return (
    <div className="min-h-screen bg-zinc-950">
      <Sidebar />
      <main className="ml-64 p-8">
        <Routes>
          <Route path="/" element={<DashboardPage />} />
          <Route path="/send" element={<ManualSendPage />} />
          <Route path="/recipients" element={<RecipientsPage />} />
          <Route path="/lists" element={<ListsPage />} />
          <Route path="/campaigns" element={<CampaignsPage />} />
          <Route path="/forms" element={<FormsPage />} />
          <Route path="/leads" element={<LeadsPage />} />
          <Route path="/automations" element={<AutomationsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/f/:slug" element={<PublicFormPage />} />
      <Route path="/*" element={<AuthenticatedApp />} />
    </Routes>
  );
}
